import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { DollarSign } from 'lucide-react';
const PricingButton = () => {
  return <div className="text-center mt-10">
      <Link to="/saas-reseller">
        
      </Link>
    </div>;
};
export default PricingButton;